// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-comments/disallowComments */

export const Colors = {
    // BRAND
    darkNavy: '#002F4D', // alias for backward compatibility, do not use
    primary: '#002F4D',
    primaryPressed: '#001C2E',

    turquoise: '#00A68D', // alias for backward compatibility, do not use
    secondary: '#00A68D',
    lightTurq: '#E8F6F4', // alias for backward compatibility, do not use
    secondarySoft: '#E8F6F4',
    mediumTurq: '#A1DBD3', // for backward compatibility, phase out

    terraCotta: '#ED6A5A', // alias for backward compatibility, do not use
    accent: '#ED6A5A',
    accentSoft: '#FAF0ED',
    mediumTerraCotta: '#F39C91', // for backward compatibility, phase out
    lightTerraCotta: '#FAF0ED', // for backward compatibility, phase out

    // SEMATIC COLORS USE ONLY WHEN THE CONTEXT REQUIRES IT, NOT AN ACCENT COLOR

    // SUCCESS
    success: '#2E8B57',
    successBackground: '#E7F4EC',
    lightGreen: '#E7F4EC', // alias for backward compatibility, do not use

    // WARNING or ATTENTION
    warning: '#F57332',
    warningBackground: '#FFF9F1',

    // ERROR or DANGER
    error: '#C3001D',
    mediumRed: '#C3001D', // alias for backward compatibility, do not use
    errorBackground: '#FADFE2',
    lightRed: '#FADFE2', // alias for backward compatibility, do not use

    //  FOR FUTURE USE MAYBE
    // textPrimary: '#183247',
    // textSecondary: '#5F6B76',
    // textMuted: '#8B98A5',

    // border: '#D8E0E5',
    // surface: '#F7F9FA',
    // background: '#FFFFFF',

    // WHITES/GRAYS/BLUES/REDS updates and consolidation coming soon

    mediumGrey: '#807E7D',
    lightGrey: '#EFEFEF',
    faintGrey: '#f9fafb',
    apronGrey: '#eaedf066',
    mediumNavy: '#335971',
    pressedNavy: '#001C2E',
    white: '#ffffff',
    white70percent: '#ffffffb3',
} as const;

/** Name of a key on the `Colors` palette (e.g. `"primary"`). */
export type ColorToken = keyof typeof Colors;

/** A CSS color string taken from the palette (a value of `Colors`). */
export type ColorsType = (typeof Colors)[ColorToken];
